import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { TailSpin } from 'react-loader-spinner';
import Axios from 'axios';
import '../style/Traductor.scss'
import Attribute from '../components/attribute';
import { publish, subscribe, unsubscribe} from '../events'
import AdminMenu from '../components/AdminMenu';
import Pagination from '../components/Pagination';
import Button from "../components/ui/Button";
import FormInputSelect from "../components/ui/FormInputSelect";
import arrow from "../assets/icons/arrow-right.svg";

const NewTraductorApp = () => {
    document.title="Traductor Qapp"
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    //Get batchId and page from url
    const batchId = searchParams.get('batchId');
    const page = parseInt(searchParams.get('page') || '1', 10);
    
    //State for session
    const [batch, setBatch] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);
    
    //Other States
    const [docData, setDocData] = useState(null)
    const [docId, setDocId] = useState("")
    const [docName, setDocName] = useState("");
    const [originLocale, setOriginLocale] = useState('')
    const [targetLocale, setTargetLocale] = useState("")
    const [keyValue, setKeyValue] = useState([])
    const [expectedAttributes, setExpectedAttributes] = useState([])
    const [authorizedFields, setAuthorizedFields] = useState([])
    const [userLocales, setUserLocales] = useState([])
    const [preLoadTrad, setPreLoadTrad] = useState([])
    const [traductedData, setTraductedData] = useState(null)
    const [enTraduction, setEnTraduction] = useState(false)
    const [enEnvoiPIM, setEnEnvoiPIM] = useState(false)
    const [error, setError] = useState(false)
    const [checkAll, setCheckAll] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [userName, setUserName] = useState("")
    const [hasExceededMaxChars, setHasExceededMaxChars] = useState(false);
    const [errorMessage, setErrorMessage] = useState("")
    const [canClose, setCanClose] = useState(false)
    const [savingAttributes, setSavingAttributes] = useState([]);
    const [glossaries, setGlossaries] = useState([]);
    const [selectedGlossaryId, setSelectedGlossaryId] = useState('');
    const [paginationHover, setPaginationHover] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(null);
    const [showUnsavedPopup, setShowUnsavedPopup] = useState(false);

    let isSaving = savingAttributes.length > 0;

    function handleProtectedNavigate(navigationAction) {
      if (traductedData) {
        setPendingNavigation(() => navigationAction);
        setShowUnsavedPopup(true);
      } else {
        navigationAction();
      }
    }

    
    const handleSaveStart = (attributeCode) => {
        setSavingAttributes((prev) => [...prev, attributeCode]);  // Add attribute to saving state
    };

    const handleSaveEnd = (attributeCode) => {
        setSavingAttributes((prev) => prev.filter((code) => code !== attributeCode));  // Remove attribute from saving state
        isSaving = savingAttributes.length > 0;
        fetchDocData();
    };


    //Creation de l'URL
    let backURL = "/api/translate"
    let errorURL = "/api/error"
    if (process.env.NODE_ENV === "development")
    {
        backURL="http://localhost:4000/api/translate"
        errorURL="http://localhost:4000/api/error"
    }
    //console.log("URL : ",backURL, " ",process.env.NODE_ENV)

    //Event Handling
    const sendAttrToPim = () => {
        setEnEnvoiPIM(true)
        publish('sendToPim');
    }

    //Async (quable) Functions
    async function fetchDocData()
    {
        if (!batch) return;
        try {
            const response = await Axios({
                method: 'GET',
                url: `${batch.quableInstance}/documents/${batch.currentDocumentId}`,
                headers:{
                    accept: 'application/ld+json',
                    Authorization:"Bearer " + batch.token
                }
            });
            const attributes = response.data.attributes;
            const nameKey = Object.keys(attributes).find(key => key.endsWith("_name"));
            const docName = nameKey
                ? (attributes[nameKey]?.fr_FR || "")
                : "";
            setDocId(response.data.id)
            setDocName(docName)
            setDocData(response.data.attributes)
            //console.log("response.data", response.data);
        }
        catch (e) {
            //console.log("fetchDocData error", e);
            setDocData(null)
        }
    }

    async function queryAttributes()
    {
        if (!batch || !batch.documentType) {
            console.error("Aucun documentType valide trouvé", batch);
            return;
        }
        try {
            let pageNum = 1;
            let attributes = [];
            let allAttributes = [];
            let hasAttributes = true;
            while (hasAttributes) {
                attributes = await Axios({
                        method: "GET",
                        url: `${batch.quableInstance}/attributes?page=${pageNum}&type[0]=localized_text&type[1]=html_text&type[2]=multiline_text&documentTypeId=${batch.documentType}`,
                        headers: {
                            Authorization: "Bearer " + batch.token
                        }
                    }
                )
                if (attributes.data["hydra:member"].length == 0) {
                    hasAttributes = false;
                }
                else {
                    allAttributes = allAttributes.concat(attributes.data["hydra:member"]);
                    pageNum++;
                }
            }
            setExpectedAttributes(allAttributes)
        }
        catch (e) {
            //console.log("Error in fetching attributes infos")
        }

    }

    async function fetchAuthorizedFields()
    {
        if (!batch) return;
        let userAuth = ""
        try {
            const user = await Axios({
                    method: "GET",
                    url: `${batch.quableInstance}/users/${batch.quableUserID}`,
                    headers: {
                        Authorization: "Bearer " + batch.token
                    }
                }
            )
            //fetch the user locales
            setUserLocales(user.data.localesAvailable)
            setUserName(user.data.username)
            if (Boolean(user.data.admin)) {
                userAuth ="admin"
                setIsAdmin(true)
            }
            else {

                if (user.data.permissionField==null)
                {
                    //console.log("Is NaN")
                    userAuth=null
                }
                else
                {
                    // //console.log("Is not NaN")
                    userAuth =user.data.permissionField
                }
            }
        }
        catch
        {
            //console.log("Error in fetching user")
        }
        //console.log("Recherche des champs autorisés",userAuth)

        if(userAuth!="admin" && userAuth!=null)
        {

            try
            {
                const authFields = await Axios({
                        method: "GET",
                        url: `${batch.quableInstance}/permissions/fields/${userAuth}`,
                        headers:{
                            Authorization:"Bearer " + batch.token
                        }
                    }
                )
                //console.log("data",authFields.data.fieldsVisible,authFields.data.fieldsEditable)
                setAuthorizedFields(authFields.data.fieldsVisible.filter(element => authFields.data.fieldsEditable.includes(element)))

            }
            catch
            {
                //console.log("Error in fetching authorized fields")
            }
        }
        else
        {
            //Admin user or access to every field
            if (userAuth=="admin")
            {
                setAuthorizedFields(["administrateur"])
            }
            else
            {
                setAuthorizedFields(["all_fields"])
            }
        }
        //console.log(authorizedFields)²
    }

    function displayAttributes(attrList, traductedData)
    {
        if (!batch) return;
        const attributesDisplayable = [];
        let compteAttributs = 0
        let maxCharactersAllowed
        for (const key in attrList)
        {
            let value;
            let localizedData = attrList[key];
            let attributeRealName = "";
            let translated=""
            let idTraduction=""
            let actualTranslation=""
            for (let i = 0; i < expectedAttributes.length; i++)
            {
                if (key == expectedAttributes[i].id && (authorizedFields.includes(key)||authorizedFields.includes("all_fields")||authorizedFields.includes("administrateur")))
                {
                    compteAttributs++
                    attributeRealName = expectedAttributes[i].name[originLocale] ? expectedAttributes[i].name[originLocale] : expectedAttributes[i].name["en-US"]
                    attributeRealName=attributeRealName?attributeRealName:expectedAttributes[i].name[originLocale.replace("_","-").replace("GB","US")]
                    
                    localizedData=attrList[key]
                    value = String(localizedData[originLocale]);
                    actualTranslation = String(localizedData[keyValue[targetLocale].PIM])
                    maxCharactersAllowed=expectedAttributes[i].options.maxCharactersAllowed?expectedAttributes[i].options.maxCharactersAllowed:999999
                    translated=traductedData ? traductedData.translatedText[compteAttributs-1]:"x"
                    idTraduction=traductedData ? traductedData.translationIds[compteAttributs-1]:"x"

                    if ((localizedData[originLocale] == null || localizedData[originLocale] === "")) {
                        value=""
                        actualTranslation=""
                    }

                    attributesDisplayable.push(
                        <Attribute
                            key={compteAttributs}
                            pimInstance={batch.quableInstance}
                            quableDocID={batch.currentDocumentId}
                            quableDocType={batch.documentType}
                            token={batch.token}
                            quableUserID={batch.quableUserID}
                            attributeCode={expectedAttributes[i].id}
                            attribute={attributeRealName}
                            trad={String(translated)}
                            value={value}
                            locale={keyValue[targetLocale].PIM}
                            maxCharactersAllowed={maxCharactersAllowed}
                            translationId={String(idTraduction)}
                            userName={userName}
                            actualTranslation={actualTranslation}
                            onSaveStart={handleSaveStart}
                            onSaveEnd={handleSaveEnd}
                        />
                    )

                    break
                }

            }
        }

        return<>{attributesDisplayable}</>
    }

    async function handleTraduction(attrList)
    {
        setErrorMessage("")
        setEnTraduction(true)
        setError(false)
        let toTraduction=[]
        let traduce= false
        for (const key in attrList)
        {
            let value;
            let localizedData = attrList[key];
            let traduceAttrFlag=false;
            for (let i = 0; i < expectedAttributes.length; i++)
            {
                if (key == expectedAttributes[i].id && (authorizedFields.includes(key)||authorizedFields.includes("all_fields")||authorizedFields.includes("administrateur")))
                {
                    traduceAttrFlag=true
                    break
                }
            }
            if (traduceAttrFlag)
            {
                //Do i traduce ?
                for (const elem in preLoadTrad)
                {
                    //console.log("elem : ",preLoadTrad[elem],' ',key)
                    if (key == preLoadTrad[elem].attributeCode && preLoadTrad[elem].instruction)
                    {
                        //Yes ! find value
                        localizedData=attrList[key]
                        value = String(localizedData[originLocale])
                        //console.log("True found, added to trad")
                        toTraduction.push(value)
                    }
                    else
                    {
                        if(key == preLoadTrad[elem].attributeCode)
                        {
                            //No... Push empty string !!!
                            //console.log("not selected to be traduced : ")
                            value=""
                            toTraduction.push(value)
                        }
                    }

                }
            }
        }
        //console.log("va etre traduit : ",toTraduction)
        //Vérifier qu'il y a au moins un element en true
        for (let i = 0; i<toTraduction.length;i++)
        {
            if(Boolean(toTraduction[i]))
            {
                traduce=true
                break
            }
        }

        if (traduce)
        {
            try {
                const traduct = await Axios(
                    {
                        method:"POST",
                        url:backURL,

                        //Version de Felipe
                        data:{
                            "input": toTraduction,
                            "inputLanguage": findLocaleName(originLocale),
                            "outputLanguage":targetLocale,
                            "quableInstanceName": batch.quableInstance,
                            "quableTokenApi": batch.token,
                            "deeplApiKey": batch.deeplKey,
                            "glossaryId": selectedGlossaryId || undefined
                        }
                    }
                )
                setTraductedData(traduct.data)
                setEnTraduction(false)
            } catch (error) {
                if (error.response) {
                    setErrorMessage(error.response.data.error || "Une erreur s'est produite pendant la traduction.");
                } else {
                    setErrorMessage("Une erreur inattendue s'est produite pendant la traduction.");
                    try {
                        const responseError = await Axios({
                            method: "POST",
                            url: errorURL,
                            data: {
                                message: "Une erreur inattendue s'est produite pendant la traduction.",
                                gravity: "minor"
                            }
                        })
                    } catch (error) {
                    }

                }
                setEnTraduction(false);
            }
        }
        else
        {
            setEnTraduction(false)
            setError(true)
        }
    }

    async function getKeyValue()
    {
        let result
        try
        {
            const JSON_LOCALS = {
                "Afrikaans" :  { "DeepL": "","PIM":"af_ZA" },
                "Arabic": { "DeepL": "AR" ,"PIM":"ar_MA"},
                "German_(AT)": { "DeepL": "DE","PIM":"de_AT" },
                "German_(CH)": { "DeepL": "DE","PIM":"de_CH" },
                "German_(DE)": { "DeepL": "DE","PIM":"de_DE" },
                "English_(AU)": { "DeepL": "EN","PIM":"en_AU" },
                "English_(CA)": { "DeepL": "EN","PIM":"en_CA" },
                "English_(CN)": { "DeepL": "EN","PIM":"en_CN" },
                "English_(GB)": { "DeepL": "EN","PIM":"en_GB" },
                "English_(IE)": { "DeepL": "EN","PIM":"en_IE" },
                "English_(SG)": { "DeepL": "EN","PIM":"en_SG" },
                "English_(US)": { "DeepL": "EN","PIM":"en_US" },
                "Spanish_(AR)": { "DeepL": "ES" ,"PIM":"es_AR"},
                "Spanish_(CL)": { "DeepL": "ES","PIM":"es_CL" },
                "Spanish_(DO)": { "DeepL": "ES","PIM":"es_DO" },
                "Spanish_(ES)": { "DeepL": "ES","PIM":"es_ES" },
                "Spanish_(MX)": { "DeepL": "ES","PIM":"es_MX" },
                "Spanish_(PA)": { "DeepL": "ES","PIM":"es_PA" },
                "Spanish_(UY)": { "DeepL": "ES","PIM":"es_UY" },
                "French_(FR)": { "DeepL": "FR","PIM":"fr_FR" },
                "French_(CA)": { "DeepL": "FR","PIM":"fr_CA" },
                "Estonian": { "DeepL": "ET","PIM":"et_EE" },
                "Hebrew": { "DeepL": "HE","PIM":"he_IL" },
                "Indonesian": { "DeepL": "ID","PIM":"id_ID" },
                "Italian": { "DeepL": "IT","PIM":"it_IT" },
                "Japanese": { "DeepL": "JA","PIM":"ja_JP" },
                "Korean": { "DeepL": "KO","PIM":"ko_KR" },
                "Latvian": { "DeepL": "LV","PIM":"lv_LV" },
                "Dutch_(NL)": { "DeepL": "NL","PIM":"nl_NL" },
                "Dutch_(BE)": { "DeepL": "NL","PIM":"nl_BE" },
                "Polish": { "DeepL": "PL","PIM":"pl_PL" },
                "Portuguese_(PT)": { "DeepL": "PT-PT","PIM":"pt_PT" },
                "Portuguese_(BR)": { "DeepL": "PT-BR","PIM":"pt_BR" },
                "Romanian": { "DeepL": "RO","PIM":"ro_RO" },
                "Russian": { "DeepL": "RU","PIM":"ru_RU" },
                "Swedish": { "DeepL": "SV","PIM":"se_SE" },
                "Thai": { "DeepL": "","PIM":"th_TH" },
                "Turkish": { "DeepL": "TR","PIM":"tr_TR" },
                "Ukrainian": { "DeepL": "UK","PIM":"uk_UA" },
                "Chinese_(CN)": { "DeepL": "ZH","PIM":"zh_CN" },
                "Chinese_(HK)": { "DeepL": "ZH","PIM":"zh_HK" },
                "Chinese_(TW)": { "DeepL": "ZH","PIM":"zh_TW" }
            };

            //const response = await Axios({
            //    method: 'GET',
            //    url: pimInstance+"/keyvalues/locals_traduction",
            //    headers:{
            //        accept: 'application/ld+json',
            //        Authorization:"Bearer " + token
            //    }
            //});
            //result=JSON.parse(response.data.value)
            //setKeyValue(result)
            setKeyValue(JSON_LOCALS)
            //console.log("key value ",Object.keys(result))
        }
        catch
        {
            //console.log("Error Document not found")
            setDocData(null)
            //setErrorFlag(true)
        }
    }

    function findLocaleName(locale, withSplit = false)
    {
        let resultKey = null;
        for (const key in keyValue) {
            if (keyValue[key].PIM === locale) {
                resultKey = key;
                if (withSplit) {
                    return resultKey.split(" ")[0]
                }
                else {
                    return resultKey
                }
            }
        }
    }

    //Effects
    //Au chargement de la page
    useEffect(() => {
      const handleCharLimitExceeded = (event) => {
        const { exceedsLimit } = event.detail;

        if (exceedsLimit) {
          setHasExceededMaxChars(true);
        } else {
          setHasExceededMaxChars(false);
        }
      };

      subscribe('attributeCharLimitExceeded', handleCharLimitExceeded);

      return () => {
        unsubscribe('attributeCharLimitExceeded', handleCharLimitExceeded);
      };
    }, []);

    const batchApiBaseUrl =
        process.env.NODE_ENV === "development"
            ? "http://localhost:4000"
            : "";

    useEffect(() => {
        if (!batchId) return;
        setLoading(true);
        Axios.get(`${batchApiBaseUrl}/batch/${batchId}?page=${page}`)
            .then(res => {
                setBatch(res.data);
                setOriginLocale(res.data.dataLocale || 'en_GB');
                setLoading(false);
                setFetchError(null);
            })
            .catch(e => {
                setFetchError(e.response?.data?.error || "Session introuvable");
                setLoading(false);
            });
    }, [batchId, page]);

    useEffect(() => {
        if (!batch) return;
        getKeyValue();
        fetchAuthorizedFields();
        queryAttributes();
        fetchDocData();
    }, [batch, originLocale]);

    useEffect(() => {
        if (keyValue && userLocales.length > 0) {
            const validLanguage = Object.keys(keyValue).find(language =>
                userLocales.includes(keyValue[language].PIM)
            );

            if (validLanguage) {
                setTargetLocale(validLanguage);
            }
        }
    }, [keyValue, userLocales]);

    useEffect(() => {
        //console.log("Fetch glossary")
        // Only fetch if both are selected (and you have a batchId)
        if (!batchId || !originLocale || !targetLocale) {
            setGlossaries([]);
            setSelectedGlossaryId('');
            return;
        }
        let targetLocalePIM = targetLocale;

        // If the targetLocale matches a label in keyValue, get the PIM code
        if (keyValue[targetLocale]) {
            targetLocalePIM = keyValue[targetLocale].PIM;
        }
        //console.log("here:", targetLocale)
        Axios.get(`${batchApiBaseUrl}/api/glossary/available`, {
            params: {
                batchId,
                originLocale,
                targetLocalePIM,
            }
        })
        .then(res => {
            setGlossaries(res.data || []);
            // auto-select first glossary or none
            setSelectedGlossaryId(res.data && res.data.length ? res.data[0].glossaryId : '');
        })
        .catch((e) => {
            setGlossaries([]);
            setSelectedGlossaryId('');
        });
    }, [batchId, originLocale, targetLocale]);

    useEffect(()=>{
        fetchDocData();
    },[originLocale])

    useEffect(()=>{
        displayAttributes(docData,traductedData)
    },[docData])

    useEffect(() => {
        setCheckAll(false)
        publish("resetAttributeStates")
        setTraductedData(null)
        preLoadTrad.map(item => { item.instruction = false; return item; });
        setPreLoadTrad(preLoadTrad)
    }, [targetLocale])

    useEffect(() => {
        let tradArray = preLoadTrad
        subscribe("chargeIntoTraductor", event => {
            setError(false)
            tradArray = tradArray.filter(item => item.attributeCode !== event.detail.attributeCode);
            tradArray.push(event.detail);
            setPreLoadTrad(tradArray)
        });

        subscribe("endOfPimUpdate",() =>{
            setTimeout(() => {
                setEnEnvoiPIM(false)
            }, 1000);
            fetchDocData()
        })

        return () => {
            unsubscribe("chargeIntoTraductor", () => console.log("killed event chargeIntoTraductor"));
            unsubscribe("endOfPimUpdate", () => console.log("killed event endOfPimUpdate"));
        }
    },[]);

    //beforeUnload
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!canClose) {
                const message = "You have unsaved changes. Are you sure you want to leave?";
                event.preventDefault();
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [canClose]);

    const originLocaleOptions = Object.keys(keyValue)
        .map((language, index) => {
            if (userLocales.includes(keyValue[language].PIM)) {
            return {
                value: keyValue[language].PIM,
                label: language
            };
        }
        return null;
    })
    .filter(Boolean);

    const targetLocaleOptions = Object.keys(keyValue)
    .map((language, index) => {
        if (userLocales.includes(keyValue[language].PIM)) {
        return {
            value: language,
            label: language
        };
        }
        return null;
    })
    .filter(Boolean);

    // ⬇️ Loading and Error UI for session
    if (loading || !originLocale || !batch) return <div>Chargement de la session...</div>;
    if (fetchError) return <div style={{ color: "red" }}>{fetchError}</div>;


    return(
        <>
            {showUnsavedPopup && (
              <div className="popup-overlay">
                <div className="popup">
                  <p>
                    Vos résultats de traduction ne sont pas enregistrés. Si vous quittez la page, votre traduction sera perdue.
                    Voulez-vous continuer ?
                  </p>
                  <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '18px'}}>
                    <Button
                        className="btn btn--primary"
                        onClick={() => {
                      setShowUnsavedPopup(false);
                      setTraductedData(null);
                      if (pendingNavigation) pendingNavigation();
                    }}
                        textButton="Oui, continuer"
                    ></Button>
                    {/* <button className="blueButton" onClick={() => {
                      setShowUnsavedPopup(false);
                      setTraductedData(null);
                      if (pendingNavigation) pendingNavigation();
                    }}>Oui, continuer</button> */}
                    <Button
                        className="btn btn--fourth"
                        onClick={() => setShowUnsavedPopup(false)}
                        textButton="Cancel"
                    ></Button>
                    {/* <button className="orangeButton" onClick={() => setShowUnsavedPopup(false)}>Cancel</button> */}
                  </div>
                </div>
              </div>
            )}
            <div className='actionBorder' style={{ position: 'relative' }}>
                <div className='actionGroup'>
                    <img src="Favicon-zento.png" alt="Zento Logo" style={{ position: 'absolute', top: '10px', left: '10px' }} />
                    <div className='selectorsDiv'>
                        <div style={{ display: 'flex', gap: '35px', alignItems: 'flex-end' }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <FormInputSelect
                                    id="glossarySelect"
                                    label="Glossaire"
                                    options={[
                                        { value: "", label: "Aucun" }, 
                                        ...glossaries.map(g => ({ value: g.glossaryId, label: g.name }))
                                    ]}
                                    value={selectedGlossaryId}
                                    onChange={e => setSelectedGlossaryId(e.target.value)}
                                    name="glossarySelect"
                                    showPlaceholder={false}
                                    colorBackgroundInput="transparent"
                                    colorSelect="black"
                                />
                                {/* <label style={{  }} htmlFor="glossarySelect">
                                    Glossary:&nbsp;
                                </label>
                                <select
                                    id="glossarySelect"
                                    className="selectBox"
                                    value={selectedGlossaryId}
                                    onChange={e => setSelectedGlossaryId(e.target.value)}
                                    style={{ marginRight: "20px" }}
                                >
                                    <option value="">None</option>
                                    {glossaries.map((g, i) => (
                                        <option key={i} value={g.glossaryId}>
                                            { g.name }
                                        </option>
                                    ))}
                                </select> */}
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <FormInputSelect
                                    id="originLocale"
                                    label="Langue d'origine"
                                    options={originLocaleOptions}
                                    value={originLocale}
                                    onChange={e => setOriginLocale(e.target.value)}
                                    name="originLocale"
                                    showPlaceholder={false}
                                    colorBackgroundInput="blueLight"
                                    colorSelect="blue"
                                    colorOption="blueDark"
                                />
                                {/* <label style={{ }} htmlFor='originLocale'>Origin Language :&nbsp;</label>
                                <select
                                    id='originLocale'
                                    className='selectBox'
                                    value={originLocale}
                                    onChange={e => setOriginLocale(e.target.value)}
                                    style={{marginRight: "20px"}}
                                >
                                    {Object.keys(keyValue).map((language, index) => {
                                        if (userLocales.includes(keyValue[language].PIM)) {
                                            return (
                                                <option key={index} value={keyValue[language].PIM}>
                                                    {language}
                                                </option>
                                            );
                                        }
                                        return null;
                                    })} 
                                </select> */}
                            </div>
                            <div className="arrowIconDiv">
                                <img src={arrow} alt="arrow icon" style={{ width: '24px', height: '24px' }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <FormInputSelect
                                    id="targetLocale"
                                    label="Langue de traduction"
                                    options={targetLocaleOptions}
                                    value={targetLocale}
                                    onChange={e => setTargetLocale(e.target.value)}
                                    name="targetLocale"
                                    showPlaceholder={false}
                                    colorBackgroundInput="blueDark"
                                    colorSelect="white"
                                    colorOption="blueDark"
                                />
                                {/* <label style={{ }} htmlFor='targetLocale'>
                                    Translation Language :&nbsp;
                                </label>
                                <select
                                    id='targetLocale'
                                    className='selectBox'
                                    value={targetLocale}
                                    onChange={e => setTargetLocale(e.target.value)}
                                >
                                    {Object.keys(keyValue).map((language, index) => {
                                        if (userLocales.includes(keyValue[language].PIM)) {
                                            return (
                                                <option key={index} value={language}>
                                                    {language}
                                                </option>
                                            );
                                        }
                                        return null;
                                    })}
                                </select> */}
                            </div>
                            <div>
                                {!(isSaving||enTraduction) &&
                                    <Button
                                        className="btn btn--primary"
                                        onClick={() => handleTraduction(docData)}
                                        textButton="Traduire"
                                    ></Button>
                                    // <button className='blueButton' onClick={() => handleTraduction(docData)}>
                                    //     Translate
                                    // </button>
                                }
                            </div>
                        </div>
                        <div className="actionButtonsContainer">
                            <div className="actionButtonsDiv">
                                <div className='buttonsDiv'>
                                    <div className='actionsButtonDiv'>
                                        {!(isSaving||enTraduction) && 
                                        <Button
                                            //className="btn btn--hyperlink--underline"
                                            className={traductedData && !hasExceededMaxChars ?'btn btn--hyperlink--underline':'btn btn--hyperlink--underline--disabled'}
                                            onClick={sendAttrToPim}
                                            disabled={traductedData && !hasExceededMaxChars ? false : true }
                                            textButton="Enregistrer"
                                        ></Button>
                                        // <button className={traductedData && !hasExceededMaxChars ?'orangeButton':'greyButton'}
                                        //         onClick={sendAttrToPim} 
                                        //         disabled={traductedData && !hasExceededMaxChars ? false : true }>
                                        //     Save in Quable
                                        // </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <AdminMenu
                            isAdmin={isAdmin}
                            handleProtectedNavigate={handleProtectedNavigate}
                            navigate={navigate}
                            batch={batch}
                            />
                        </div>
                    </div>
                    {(enTraduction || isSaving) &&
                        <TailSpin
                            visible={true}
                            height="80"
                            width="1000"
                            color="#4d8acc"
                            radius="1"
                        />}
                    <p style={{color:"red"}}>{error&&"Aucun champ n'est sélectionné"}</p>
                    <p>{enTraduction && "Currently translating "} {isSaving && " Saving in Quable"}</p>
                </div>
            </div>
            <div className='parentDiv'>
                <div className='utilsDiv'>
                    <div className="utilsDivContainer">
                        <input
                            id='checkall'
                            type='checkbox'
                            checked={checkAll}
                            onChange={()=>{
                                const newState = !checkAll;
                                setCheckAll(newState);
                                publish("checkAllEvent", { instruction: newState })
                            }}
                        />
                        <label className="typeTitleBold" htmlFor='checkall'
                                style={{ marginLeft: '8px', marginRight: '8px' }}
                            >
                            Tout sélectionner
                        </label>
                        <Button
                            className="btn btn--secondary"
                            onClick={()=>window.location.reload()}
                            textButton="Réinitialiser"
                        ></Button>
                        {/* <button className='redButton' onClick={()=>window.location.reload()}>Reset</button> */}
                    </div>
                    <div className="productName">
                        <span className="typeTitle">Id du document : <span className="typeTitleBold">{ docId ? ` ${docId}` : " Pas de document trouvé" }</span> - Nom : <span className="typeTitleBold">{ docName ? ` ${docName}` : " Pas de document trouvé" }</span></span>
                        
                    </div>
                    {errorMessage && (
                    <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                    </div>
                    )}
                    <div className="paginationContainer">
                        <Pagination
                            page={page}
                            totalPages={batch.totalPages}
                            batchId={batchId}
                            handleProtectedNavigate={handleProtectedNavigate}
                            navigate={navigate}
                        />
                    </div>
                </div>
                { docData && <div className='attributesContainer'>{displayAttributes(docData, traductedData)}</div> }
                <p>{traductedData ? "Traduit avec " + traductedData.service : ""}</p>
            </div>
        </>)
};

export default NewTraductorApp;